import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(
	'ac6b3a3689177b62c695985398e4559bTz0xMzAyMTcsRT0xODEzMTAzOTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI=',
)
//
